import { useField, useFormikContext } from "formik";
import { FormLabel, FormControl, InputGroup, Text } from "@chakra-ui/react";
import ReactSelect from "react-select";

const SearchAbleSelectInput = ({
  label,
  name = "",
  placeholder,
  labelColor,
  labelSize,
  style,
  selectedValue,
  onChangeHandler,
  isArray = false,
  disabled = false,
  children,
}) => {
  //   const [selectedValue, setSelectedValue] = useState(null);
  const [formikField, meta] = useField(name);
  const formik = useFormikContext();

  const options = children?.map((child) => ({
    value: child?.props?.value,
    label: child?.props?.children,
  }));

  return (
    <FormControl style={style}>
      <FormLabel
        color={labelColor || "#000000"}
        marginBottom={2}
        fontFamily={"PlusJakartaSansMedium"}
        fontSize={labelSize || "12px"}
        lineHeight={"16px"}
        textTransform={"capitalize"}
      >
        {label}
      </FormLabel>
      <InputGroup>
        <ReactSelect
          isClearable
          value={selectedValue}
          placeholder={placeholder}
          onChange={onChangeHandler}
          options={options}
          menuPortalTarget={document.body}
          styles={{
            container: (styles) => ({ ...styles, width: "100%" }),
            control: (styles) => ({
              ...styles,
              borderColor: "#E2E2E2",
              borderRadius: 4,
              paddingBlock: 5,
            }),
            menuPortal: (styles) => ({ ...styles, zIndex: 9999 }),
          }}
          isDisabled={disabled}
        />
      </InputGroup>
      {meta?.touched && meta?.error && !isArray && (
        <Text
          color="#FF0000"
          fontSize="12px"
          fontFamily="PlusJakartaSansRegular"
          lineHeight="20px"
        >
          {meta.error}
        </Text>
      )}
    </FormControl>
  );
};

export default SearchAbleSelectInput;
